import React from 'react'

import ContactUsCTR from '../containers/contact-us/ContactUsCTR'

function ContactUs() {
    return (
        <>
            <ContactUsCTR />
        </>
    )
}

export default ContactUs
